import FlowConfigBase from '#client/config/FlowConfigBase';
import { ENABLE_GOOGLE_PAY } from '#client/constants/experimentFlags';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'llc-vx',
  pageKeys: [
    PAGE_KEYS.BUSINESS_INFO,
    PAGE_KEYS.CONTACT_INFO,
    PAGE_KEYS.BUSINESS_EXPERIENCE,
    PAGE_KEYS.BUSINESS_STAGE,
    PAGE_KEYS.INDUSTRY,
    PAGE_KEYS.REGISTERED_AGENT,
    PAGE_KEYS.PACKAGE_SELECTION,
    PAGE_KEYS.WFC,
    PAGE_KEYS.EIN,
    PAGE_KEYS.OPERATING_AGREEMENT,
    PAGE_KEYS.MONEY_PRO,
    PAGE_KEYS.RUSH_FILING,
    PAGE_KEYS.CHECKOUT
  ],
  pageConfigs: {
    [PAGES.BUSINESS_INFO.pageComponent]: {
      pageComponentProps: { formationCountyStates: new Set(['NY']) }
    },
    [PAGES.WFC.pageComponent]: { pageComponentProps: { couponCode: '199_off_first_year' } },
    [PAGES.PACKAGE_SELECTION.pageComponent]: {
      pageComponentProps: { couponCodes: { worry_free_service: '199_off_first_year' } }
    }
  },
  entityType: 'llc',
  currentExperiment: null,
  experiments: {
    [ENABLE_GOOGLE_PAY]: {
      evaluateOnPages: [PAGES.CHECKOUT.pageComponent],
      // An experiment flag is used to enable Google Pay. We just need to expose the experiment flag to the checkout page. No variant overrides are needed.
      variations: {
        control: {},
        variation: {}
      }
    }
  },
  hasFormation: true,
  isPrimary: true,
  postOrderAutoLogin: true,
  postOrderRedirect: ROUTES.SHOP_LLC_ADDONS,
  priceListUuids: {
    development: '3c9da872-c96d-4e28-be04-4dd8cf8e1a2e',
    production: '19a705a4-3241-4f65-aef1-74a95f6f49b8'
  }
});
